export default {
    DEFAULT_REDIRCT: './#/resource-list',
    CONTACT_US: {
        email: 'isss.cfps@pku.edu.cn',
        phone: '(010)62767908 ',
        address: '北京大学理科5号楼四层 '
    },
    ROUTES: [
        {
            path: '/commonLogin',
            component: () => import('@/pages_cfps/login-register'),
            redirect: '/emailLogin',
            children: [
                {
                    path: '/emailLogin',
                    component: () => import('@/pages_cfps/login-register/email-login.vue'),
                },
                {
                    path: '/emailSafety',
                    component: () => import('@/pages_cfps/login-register/email-safety.vue'),
                },
                {
                    path: '/resetPassword',
                    component: () => import('@/pages_cfps/login-register/reset-password.vue'),
                },
            ],
        },
        {
            path: '/commonRegister',
            component: () => import('@/pages_cfps/login-register'),
            redirect: '/emailRegister',
            children: [
                {
                    path: '/emailRegister',
                    component: () => import('@/pages_cfps/login-register/email-register.vue'),
                },
            ],
        },
        {
            path: '/noLogin',
            redirect: '/commonLogin'
        },
        {
            path: '/repeatLogin',
            redirect: '/commonLogin'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/config/private-project/cfps.js